export const formatHour = (hour: number) =>
  hour.toString().padStart(2, "0") + ":00";
